{
  "name": "payment-fe",
  "version": "0.0.2-2-add-file-uploading.10",
  "scripts": {
    "install": "cp ./package.json ./public",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint src/**/*.scss --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.1.2",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/material": "^21.1.2",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.2.0",
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.0",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@sparbanken-syd/teradata-user": "3.1.1-2339695602.0",
    "@stylistic/eslint-plugin": "^5.7.1",
    "@types/jmespath": "^0",
    "@vitest/coverage-v8": "4.0.18",
    "angular-eslint": "^21.2.0",
    "eslint": "^9.39.2",
    "fast-xml-parser": "^5.4.2",
    "jmespath": "^0.16.0",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.6",
    "stylelint": "^17.1.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.54.0",
    "vitest": "^4.0.8",
    "xml-js": "^1.6.11"
  }
}
